import {chart} from '@xh/hoist/cmp/chart';
import {hframe} from '@xh/hoist/cmp/layout';
import {hoistCmp, uses} from '@xh/hoist/core';
import {button} from '@xh/hoist/desktop/cmp/button';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {Icon} from '@xh/hoist/icon';
import {chartSpecConfigurator} from './configurator/ChartSpecConfigurator';
import {ConfigurableChartModel} from './ConfigurableChartModel';
import '../gridSpec/GridSpec.scss';

/**
 * A chart driven by a ChartSpec. While configuring, the chart goes modal with the configurator
 * docked on the right.
 */
export const configurableChart = hoistCmp.factory<ConfigurableChartModel>({
    model: uses(ConfigurableChartModel),
    className: 'cs-configurable-chart',
    render({model, className}) {
        return panel({
            className,
            model: model.panelModel,
            item: hframe(
                chart({model: model.chartModel}),
                panel({
                    omit: !model.isConfiguring,
                    className: 'gs-configurator-panel',
                    scrollable: true,
                    modelConfig: {
                        side: 'right',
                        defaultSize: 360,
                        minSize: 300,
                        maxSize: 700,
                        collapsible: false
                    },
                    compactHeader: true,
                    title: model.title ? `Configure: ${model.title}` : 'Configure',
                    icon: Icon.gear(),
                    headerItems: [button({icon: Icon.close(), minimal: true, onClick: () => model.closeConfigurator()})],
                    item: chartSpecConfigurator({model: model.configuratorModel})
                })
            )
        });
    }
});
